<h1 class="pt-8 text-center text-6xl font-semibold text-info-content">
  Account History
</h1>
